import { ChangeDetectionStrategy, Component, computed, inject, input, signal, TemplateRef, ViewChild } from '@angular/core';
import { take } from 'rxjs/operators';
import { OrderCappingDetails } from '../../models/product.model';
import { ORDER_CAPPING_ICONS, OrderCappingStatus } from '../../config/app.config';
import { ICON_TYPE, IconModule } from '@spartacus/storefront';
import { I18nModule } from '@spartacus/core';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import { NgbModal, NgbPopover } from '@ng-bootstrap/ng-bootstrap';
import { OrderCappingToastsComponent } from '../../components/order-capping-toasts/order-capping-toasts.component';

@Component({
  selector: 'sanofi-order-capping',
  standalone: true,
  imports: [
    IconModule,
    I18nModule,
    FaIconComponent,
    OrderCappingToastsComponent,
    NgbPopover
  ],
  templateUrl: './order-capping.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class OrderCappingComponent {
  @ViewChild('quantityLimitModal') public quantityLimitModal: TemplateRef<any>;

  orderCappingDetails = input<OrderCappingDetails>(null);
  quantityLimitReached = input<boolean>(false);
  firstLoad = input<boolean>(false);
  popoverPlacement = input<string>('auto');
  status = input<OrderCappingStatus>(OrderCappingStatus.QUANTITY_LIMIT);
  baseProductName = input.required<string>();
  productAnchorId = input<string>(null);
  cartQty = input<number>(0);
  cartMode = input<boolean>(false);

  remainingAfterCart = computed(() =>
    Math.max(0, parseInt(this.orderCappingDetails()?.availableQty || '0', 10) - this.cartQty())
  );

  pillContext = computed(() => this.status() + 'Cart');

  pillIcon = computed(() => faInfoCircle);

  protected readonly ICON_TYPE = ICON_TYPE;
  protected readonly emailAddress = 'blood-disordersCS@sanofi.com';

  isModalOpen = signal(false);

  private readonly modalService = inject(NgbModal);

  openModal(): void {
    if (this.quantityLimitModal) {
      this.isModalOpen.set(true);
      const ref = this.modalService.open(this.quantityLimitModal, { centered: true, ariaLabelledBy: 'quantityLimitModalTitle' });
      ref.hidden.pipe(take(1)).subscribe(() => this.isModalOpen.set(false));
    }
  }
}
